const CACHE_KEY = 'coelab_chat_embed_token_v1';
// Refresh 5 minutes before the JWT actually expires so the iframe never
// receives a token that is about to expire mid-session.
const EXPIRY_BUFFER_MS = 5 * 60 * 1000;

function getTokenExpiry(token: string): number {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : 0;
  } catch {
    return 0;
  }
}

export function getCachedEmbedToken(): string | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { token } = JSON.parse(raw) as { token: string };
    if (!token) return null;
    const expiry = getTokenExpiry(token);
    if (expiry > 0 && Date.now() < expiry - EXPIRY_BUFFER_MS) return token;
    sessionStorage.removeItem(CACHE_KEY);
    return null;
  } catch {
    return null;
  }
}

export function setCachedEmbedToken(token: string): void {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ token }));
  } catch {
    // sessionStorage unavailable (e.g. some private-browsing configurations) — no-op
  }
}
